import React from 'react';
import PropTypes from 'prop-types';
import { MdFileUpload } from 'react-icons/md'
import {ReactPlannerComponents, ReactPlannerConstants} from 'react-planner';
import { FragmentExporter } from '../export/fragment-exporter';

const {
  MODE_3D_FIRST_PERSON,
  MODE_3D_VIEW
} = ReactPlannerConstants;

const { ToolbarButton } = ReactPlannerComponents.ToolbarComponents;

export default function ToolbarExportButton(props, {translator}) {

  const mode = props.mode;
  const exporter = new FragmentExporter();

  let exportScene = () => {
    if(!window.__sceneGraph) {
      console.log("Scene graph not defined!");
      return;
    }
    exporter.export(props);
  };

  if ([MODE_3D_FIRST_PERSON, MODE_3D_VIEW].includes(mode)) {
    return (
      <ToolbarButton active={false} tooltip={translator.t('Export')} onClick={exportScene}>
        <MdFileUpload/>
      </ToolbarButton>
    );
  }

  return null;

}

ToolbarExportButton.propTypes = {
  mode: PropTypes.string.isRequired,
};

ToolbarExportButton.contextTypes = {
  translator: PropTypes.object.isRequired,
};
